import { CalendarDay } from '../types';
import './TripHeader.css';

interface TripHeaderProps {
  calendar: CalendarDay[];
}

export default function TripHeader({ calendar }: TripHeaderProps) {
  const startDate = calendar[0]?.date_str || '';
  const endDate = calendar[calendar.length - 1]?.date_str || '';

  return (
    <header className="trip-header">
      <h1 className="trip-title">Kids 2026 Ketzev Program</h1>
      <p className="trip-dates">
        {startDate} - {endDate}
      </p>
    </header>
  );
}

